import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=c47ab4b0&scoped=true"
import script from "./solution.vue?vue&type=script&lang=ts"
export * from "./solution.vue?vue&type=script&lang=ts"
import style0 from "./solution.vue?vue&type=style&index=0&id=c47ab4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ab4b0",
  null
  
)

export default component.exports